
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import Message from '@/components/message.vue';

	import {
		productImgTemplateSave,
		productImgTemplateList,
		productImgTemplateSetDefault,
		productImgTemplateDel,
	} from '@/api/supplier'

	import {
		imgHost
	} from '@/utils/config';

	@Component({
		name: 'product-pictures-templete',
		components: {
			PageFooter,
			UploadImg,
			Message
		}
	})
	export default class productPicturesTemplete extends Vue {
		private imgHost = imgHost;
		private previewImageUrl = '';
		private showPreview = false;
		private templates = [];

		private showDialog = false;
		private selectData:any = {};
		private selectIndex = -1;
		
		private mounted() {
			this.getData()
		}

		private handleAddTemplate(){
			this.templates.push({
				Id: 0,
				TemplateName: '',
				TemplateWatermarkImgUrl: '',
				IsDefault: false,
				images: []
			})
		}

		private uploadSucess(list, item){
			item.images = list;
			item.TemplateWatermarkImgUrl = list[0];
		}
		private showPreviewPop(record){
			this.previewImageUrl = this.imgHost + record.images[0];
			this.showPreview = true;
		}
		private handleSave(){
			let str = '';
			this.templates.map(item=>{
				if (!item.Id && !str){
					if (!item.TemplateName){
						str = '请设置模板名称';
					}else if (!item.images.length){
						str = '请上传水印图';
					}
				}
			})

			if (str){
				this.$message.error(str);
				return;
			}

			this.save();
		}
		private async save(){
			try {
				const res: any = await productImgTemplateSave({
					ProductImgTemplateSaveDtos: this.templates
				})
				this.$message.success('保存成功');
				this.getData();

			} catch (e) {
				console.log(e);
			}
		}
		private async handleSetDefault(record, index){
			if (record.IsDefault){
				record.IsDefault = false;
				return;
			}
			this.templates.map((item, i)=>{
				item.IsDefault = i === index;
			})
			// if (!record.Id){
			// 	record.
			// }
			return;
			try {
				const res: any = await productImgTemplateSetDefault({
					Id: record.Id,
					IsDefault: !record.IsDefault
				})
				this.$message.success('操作成功');
				this.getData();

			} catch (e) {
				console.log(e);
			}
		}
		private handleDelete(record, index){
			// if (record.Id && record.IsDefault){
			// 	this.$message.error('默认模版不支持删除');
			// 	return;
			// }
			this.showDialog = true;
			this.selectIndex = index;
			this.selectData = record;
		}
		private async confirmDelete(){
			this.templates.splice(this.selectIndex, 1);
			return;
			
			try {
				const res: any = await productImgTemplateDel({
					Id: this.selectData.Id
				})
				this.showDialog = false;
				this.$message.success('操作成功');
				this.getData();

			} catch (e) {
				console.log(e);
			}
		}
		private async getData() {
			try {
				const res: any = await productImgTemplateList({});
				this.templates = res.Result.map(item=>{
					if (item.TemplateWatermarkImgUrl){
						item.images = [item.TemplateWatermarkImgUrl];
					}else{
						item.images = [];
					}
					return item;
				})
			} catch (e) {
				console.log(e);
			}
		}
	}
